import {BRAND_NAME} from './config'
export const DEFAULT_META_DESCRIPTION = `Boost your popularity in social media by ${BRAND_NAME} services. We provide fast, reliable, real and safe packages. You'll find something that suits you, no matter if you're looking to buy packages for your personal or a company account.`
